import './index.css'

import React from 'react'
import { Link } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'

import { useSelector } from 'hooks/use-redux'
import type { Shortlist as ShortlistType } from 'types/shortlist'

import { Button } from 'components/ds'
import LegacyButton from 'components/ui/button'

const MAX_LENGTH_NAME_SECTION = 255

type Props = {
  shortlist: ShortlistType
  activeUploads: boolean
}

function Save({ shortlist, activeUploads }: Props) {
  const location = useSelector(getLocationBeforeTransitions)

  if (shortlist.items.length === 0) {
    return <LegacyButton caption="Save" compact disabled />
  }

  const containNotProcessedTracks =
    shortlist.items.filter(item => !item.track.uploaded).length > 0
  const containInvalidSection = shortlist.sections.find(
    s => s.name.length > MAX_LENGTH_NAME_SECTION,
  )

  if (activeUploads || containNotProcessedTracks || containInvalidSection) {
    return <LegacyButton caption="Save" compact disabled />
  }

  const { id } = shortlist
  const isOnSearchPage = location?.pathname?.startsWith('/search')
  const returnPath = isOnSearchPage
    ? location.pathname + (location.search || '')
    : '/'

  const saveLocation = {
    pathname: isOnSearchPage
      ? `/search/shortlists/${id}/save`
      : `/shortlists/${id}/save`,
    state: { returnPath },
  }

  if (!shortlist.saved) {
    return (
      <Button
        variant="solid"
        highContrast
        size="1"
        asChild
        onClick={() =>
          mixpanel.sendPureEvent('Playlist Creator - Save playlist')
        }
      >
        <Link to={saveLocation.pathname} state={saveLocation.state}>
          Save
        </Link>
      </Button>
    )
  }

  return (
    <LegacyButton
      link={saveLocation}
      caption="Save"
      compact
      onClick={() => mixpanel.sendPureEvent('Playlist Creator - Save playlist')}
    />
  )
}

export default Save
